import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: 'cc-ng1-user-list'
})
export class Ng1UserListDirective extends UpgradeComponent {
  @Input() userList;
  @Input() userStats;
  @Input() state;
  @Input() userIndex;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('users', elementRef, injector);
  }
}
